<div class="banner w-100" [ngClass]="getStyleClasses()" [style.minHeight]="bannerHeight">
  <div class="container-fluid px-0 d-flex" [style.minHeight]="bannerHeight">
    <ng-content></ng-content>
  </div>
</div>
